function userReducer(state, action) {
  if (typeof state === "undefined") {
    state = null; // If state is undefined, initialize it with a default value
  }
  if (action.type === "LOGIN") {
    return action.payload;
  } else {
    return state; // In case an action is passed in we don't understand
  }
}

export default userReducer;
